import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, MapPin, ArrowRight } from 'lucide-react';
const installs = [{
  suburb: 'Karrinyup',
  brand: 'Mitsubishi Electric',
  system: '14kW ducted reverse cycle',
  kw: '14',
  zones: '6',
  duration: '2 days',
  home: '4 bed double brick',
  tone: 'brand'
}, {
  suburb: 'Subiaco',
  brand: 'Mitsubishi Electric',
  system: '7.1kW multi head split',
  kw: '7.1',
  zones: '3',
  duration: '1 day',
  home: '2 bed apartment',
  tone: 'light'
}, {
  suburb: 'Hillarys',
  brand: 'Daikin',
  system: '16kW ducted with iZone',
  kw: '16',
  zones: '8',
  duration: '3 days',
  home: '5 bed two storey',
  tone: 'accent'
}, {
  suburb: 'Mount Lawley',
  brand: 'Mitsubishi Electric',
  system: '5kW single split',
  kw: '5',
  zones: '1',
  duration: '1 day',
  home: 'Master bedroom',
  tone: 'light'
}, {
  suburb: 'Sorrento',
  brand: 'Rinnai HRV',
  system: '14kW ducted whole home',
  kw: '14',
  zones: '7',
  duration: '3 days',
  home: '4 bed coastal home',
  tone: 'brand'
}, {
  suburb: 'Joondalup',
  brand: 'Daikin',
  system: '10kW ducted',
  kw: '10',
  zones: '4',
  duration: '2 days',
  home: '3 bed family home',
  tone: 'light'
}] as const;
export function InstallGallery() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (dir: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const amount = scrollRef.current.offsetWidth * 0.8;
    scrollRef.current.scrollBy({
      left: dir === 'left' ? -amount : amount,
      behavior: 'smooth'
    });
  };
  return <section className="bg-white py-20 md:py-28 overflow-hidden" data-id="element-407" data-mp="r808crq54aal">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-408" data-mp="3jgw613yzdd8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12" data-id="element-409" data-mp="3hmeqwrwq3dw">
          <div className="max-w-2xl" data-id="element-410" data-mp="3up8kqw23mhxx">
            <div className="text-xs font-semibold uppercase tracking-widest text-brand mb-4" data-id="element-411" data-mp="1ymn7cm1iq5wn">
              Recent Perth Installs
            </div>
            <h2 className="text-2xl md:text-4xl font-bold tracking-tight text-ink leading-tight" data-id="element-412" data-mp="23kf3xtd3yg76">
              Six months of Perth jobs.
            </h2>
            <p className="mt-4 text-lg text-stone-600" data-id="element-413" data-mp="2cds6ln0z4w6g">
              Real Perth homes, clearly documented systems and consistent installation standards.
            </p>
          </div>

          <div className="flex items-center gap-2" data-id="element-414" data-mp="1kmugmqpzrpoo">
            <button onClick={() => scroll('left')} className="w-12 h-12 rounded-full border-2 border-stone-200 hover:border-brand hover:bg-brand hover:text-white flex items-center justify-center transition-all" aria-label="Previous installs" data-id="element-415" data-mp="1knnh59ycxiyd">
              <ChevronLeft size={18} data-id="element-416" data-mp="302tacwyv3j5e" />
            </button>
            <button onClick={() => scroll('right')} className="w-12 h-12 rounded-full border-2 border-stone-200 hover:border-brand hover:bg-brand hover:text-white flex items-center justify-center transition-all" aria-label="Next installs" data-id="element-417" data-mp="352fod8mil3f9">
              <ChevronRight size={18} data-id="element-418" data-mp="35gkwe4d6vr6w" />
            </button>
          </div>
        </div>
      </div>

      <div ref={scrollRef} className="hide-scrollbar overflow-x-auto px-4 sm:px-6 lg:px-[calc((100vw-1280px)/2+32px)] snap-x snap-mandatory" data-id="element-419" data-mp="31fhgjhv55v5o">
        <div className="flex gap-5 pb-4" data-id="element-420" data-mp="2we1vvqwvlqnt">
          {installs.map((install, i) => {
          const isBrand = install.tone === 'brand';
          const isAccent = install.tone === 'accent';
          const isLight = install.tone === 'light';
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.05
          }} className={`snap-start flex-shrink-0 w-[300px] sm:w-[340px] lg:w-[380px] rounded-2xl p-7 lg:p-8 flex flex-col shadow-md hover:shadow-xl transition-all ${isBrand ? 'bg-brand text-white' : isAccent ? 'bg-accent text-ink' : 'bg-white text-ink border border-stone-200'}`} data-id="element-421" data-mp="2ihoppdxslbon" data-mpi={i}>
                <div className="flex items-center justify-between mb-8" data-id="element-422" data-mp="9sffyxk963og">
                  <span className={`inline-flex items-center gap-1.5 px-3 h-7 rounded-full text-[11px] font-semibold uppercase tracking-wider ${isBrand ? 'bg-white/15 text-white' : isAccent ? 'bg-ink/15 text-ink' : 'bg-brand text-white'}`} data-id="element-423" data-mp="9tqnn8gtjvku">
                    <MapPin size={11} data-id="element-424" data-mp="3i8r392yvhbro" /> {install.suburb}
                  </span>
                  <div className={`text-[11px] uppercase tracking-wider font-semibold ${isBrand ? 'text-white/60' : isAccent ? 'text-ink/60' : 'text-stone-400'}`} data-id="element-425" data-mp="3n6afjxc0fegz">
                    #{String(i + 1).padStart(2, '0')}
                  </div>
                </div>

                <div className={`text-[11px] uppercase tracking-widest font-semibold mb-3 ${isBrand ? 'text-accent' : isAccent ? 'text-ink' : 'text-brand'}`} data-id="element-426" data-mp="3cn9oshi4m2xf">
                  {install.brand}
                </div>

                <h3 className="text-2xl font-bold tracking-tight leading-tight mb-2 flex-grow" data-id="element-427" data-mp="3mi1rfzqkffz2">
                  {install.system}
                </h3>

                <p className={`text-sm mb-7 ${isBrand ? 'text-white/75' : isAccent ? 'text-ink/75' : 'text-stone-600'}`} data-id="element-428" data-mp="3ib3xi15qpy">
                  {install.home}
                </p>

                <div className={`grid grid-cols-3 gap-2 pt-5 border-t ${isBrand ? 'border-white/15' : isAccent ? 'border-ink/15' : 'border-stone-200'}`} data-id="element-429" data-mp="961a26ip3j6x">
                  <div data-id="element-430" data-mp="2xzoacbpxcb8m">
                    <div className={`text-[10px] uppercase tracking-wider font-semibold mb-1 ${isBrand || isAccent ? 'opacity-60' : 'text-stone-500'}`} data-id="element-431" data-mp="2xwa956szy82r">
                      Capacity
                    </div>
                    <div className="text-xl font-bold tracking-tight tabular-nums" data-id="element-432" data-mp="3bq1iof6q9ryh">
                      {install.kw}
                      <span className="text-xs font-normal ml-0.5 opacity-60" data-id="element-433" data-mp="3go32x3fw3xbj">
                        kW
                      </span>
                    </div>
                  </div>
                  <div data-id="element-434" data-mp="3qo3pcy922tjy">
                    <div className={`text-[10px] uppercase tracking-wider font-semibold mb-1 ${isBrand || isAccent ? 'opacity-60' : 'text-stone-500'}`} data-id="element-435" data-mp="3qnk5hbzuhv3a">
                      Zones
                    </div>
                    <div className="text-xl font-bold tracking-tight tabular-nums" data-id="element-436" data-mp="20acujkhqmmw3">
                      {install.zones}
                    </div>
                  </div>
                  <div data-id="element-437" data-mp="1st6jcykjfnmu">
                    <div className={`text-[10px] uppercase tracking-wider font-semibold mb-1 ${isBrand || isAccent ? 'opacity-60' : 'text-stone-500'}`} data-id="element-438" data-mp="1o0n7q75ev2ko">
                      Install
                    </div>
                    <div className="text-xl font-bold tracking-tight whitespace-nowrap" data-id="element-439" data-mp="1f19v55lzpxvq">
                      {install.duration}
                    </div>
                  </div>
                </div>
              </motion.div>;
        })}

          {/* CTA card */}
          <motion.a href="#quote-form" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="snap-start flex-shrink-0 w-[300px] sm:w-[340px] lg:w-[380px] rounded-2xl bg-white border-2 border-dashed border-stone-300 hover:border-brand hover:bg-brand-50 transition-all p-8 flex flex-col justify-between group" data-id="element-440" data-mp="22o8dk8to7fwa">
            <div className="w-12 h-12 rounded-full bg-brand text-white flex items-center justify-center group-hover:bg-accent group-hover:text-ink transition-colors" data-id="element-441" data-mp="2ch7oc5iqxzhw">
              <ArrowRight size={20} className="group-hover:translate-x-0.5 transition-transform" data-id="element-442" data-mp="3553h4z57379e" />
            </div>
            <div data-id="element-443" data-mp="2ve8rdksqppj7">
              <div className="text-xs uppercase tracking-widest font-semibold text-brand mb-2" data-id="element-444" data-mp="2veqy5bd13m5d">
                Yours next?
              </div>
              <div className="text-2xl font-bold tracking-tight leading-tight text-ink mb-3" data-id="element-445" data-mp="30az88acdcp5o">
                Add your home to the list.
              </div>
              <p className="text-stone-600 text-sm mb-5" data-id="element-446" data-mp="3stmsjnjjk05p">
                Free on site quote. Written estimate in 48 hours.
              </p>
              <span className="inline-flex items-center gap-2 text-sm font-semibold text-brand" data-id="element-447" data-mp="1hc9pxkygx2sl">
                Book a quote <ArrowRight size={14} data-id="element-448" data-mp="1cdgl0gx8yk41" />
              </span>
            </div>
          </motion.a>
        </div>
      </div>
    </section>;
}